import { useState } from 'react';
import { Button } from '@iwoca/orion';
import { useRouterApplicationId } from 'components/Signup/hooks/useRouterApplicationId';
import { useSignupStep } from 'components/Signup/hooks/useSignupStep';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const ContinueToDocuments = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const applicationId = useRouterApplicationId();
  const { updateLatestAllowedStep } = useSignupStep();
  const { checkIntroducerPermission } = useIntroducerContext();

  const handleClick = async () => {
    setIsLoading(true);
    await updateLatestAllowedStep('new/documents');
    navigate(PATH_NAMES.newApplicationDocuments({ applicationId }));
    setIsLoading(false);
  };

  return (
    <Button
      variant="denim"
      data-testid="continue-to-documents"
      loading={isLoading}
      onClick={handleClick}
      disabled={!checkIntroducerPermission('can_upload_broker_documents')}
    >
      Upload documents
    </Button>
  );
};
